import React from "react"

const ProductHero = ({ children }) => (
  <section className="h-full overflow-hidden lg:h-screen">
    <div className="flex h-full flex-col p-3 lg:flex-row lg:p-0">
      {children}
    </div>
  </section>
)

export default ProductHero
